import * as THREE from 'three'
import { signTexture } from '../../Utils/localizedTexture.js'
import { t } from '../../../content/i18n.js'

// tools/blender/crossroads.py ile aynı: [çeviri anahtarı, direk x, direk y, yön açısı (0: -Y'ye, 90: +X'e bakar), ok yönü (yerel x)]
const SIGNS = [
    ['signPlayground', - 8.94, 0.0, 0, - 1],
    ['signProjects', 8.91, 0.0, 0, 1],
    ['signContact', 0.04, - 8.98, 90, - 1]
]
// Ok panosu (crossroads.py): kuyruk -0.3, dikdörtgen 2.45, ön yüz yerel y = -(0.09 + 0.12), yükseklik 3.5
const BOARD = { tail: - 0.3, body: 2.45, front: - 0.21, z: 3.5 }
const TEXT = { width: 2.2, height: 0.56 }

export default class CrossroadsSection
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setStatic()
        this.setSigns()
        this.setTiles()
    }

    setStatic()
    {
        this.objects.add({
            base: this.resources.items.crossroadsStaticBase.scene,
            collision: this.resources.items.crossroadsStaticCollision.scene,
            floorShadowTexture: this.resources.items.crossroadsStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }

    setTiles()
    {
        // To intro
        this.tiles.add({
            start: new THREE.Vector2(this.x, - 10),
            delta: new THREE.Vector2(0, this.y + 14)
        })

        // To projects
        this.tiles.add({
            start: new THREE.Vector2(this.x + 12.5, this.y),
            delta: new THREE.Vector2(7.5, 0)
        })

        // To projects
        this.tiles.add({
            start: new THREE.Vector2(this.x - 13, this.y),
            delta: new THREE.Vector2(- 6, 0)
        })
    }

    setSigns()
    {
        // Yazı panonun dikdörtgen kısmına ortalanır (ok ucuna taşmaz); düzlem kabı yön açısıyla döner (ayna yok)
        this.signs = SIGNS.map(([_key, _x, _y, _angle, _direction]) =>
        {
            const texture = signTexture([{ text: () => t(_key), color: '#2b2f73', size: 0.5, y: 0.52 }], 1024, Math.round(1024 * TEXT.height / TEXT.width))
            const group = new THREE.Object3D()
            group.position.set(this.x + _x, this.y + _y, BOARD.z)
            group.rotation.z = THREE.MathUtils.degToRad(_angle)
            const plane = new THREE.Mesh(
                new THREE.PlaneGeometry(TEXT.width, TEXT.height),
                new THREE.MeshBasicMaterial({ map: texture, transparent: true, depthWrite: false, toneMapped: false })
            )
            plane.rotation.x = Math.PI * 0.5
            plane.position.x = _direction * (BOARD.tail + BOARD.body * 0.5)
            plane.position.y = BOARD.front - 0.006
            group.add(plane)
            this.container.add(group)
            return { key: _key, group, plane, texture }
        })
    }
}
